import styled from '@emotion/styled'
import MuiBox from '@mui/material/Box'

export const Box = styled(MuiBox)`
	${({ theme }) => `
		border-color: ${theme.palette.borderColors.darkGray} !important;
  `}
`
